const primaryMain = '#004C97';
const primaryMainOpacity = 'rgba(0, 76, 151, 0.9)';
const secondaryMain = '#DC8633';
const secondaryMainOpacity = 'rgba(220, 134, 51, 0.5)';
const secondaryLight = '#7FA9AE';
const tertiaryMain = '#000000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
